import { FC, useState, createContext } from 'react';
type SidebarContext = {
  sidebarToggle: any;
  flightPlansBadge: string;
  toggleSidebar: () => void;
  closeSidebar: () => void;
  setFlightPlansBadge: (badge: string) => void;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SidebarContext = createContext<SidebarContext>(
  {} as SidebarContext
);

export const SidebarProvider = (props: any) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [flightPlansBadge, setFlightPlansBadge] = useState(null);

  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };

  return (
    <SidebarContext.Provider
      value={{ sidebarToggle, flightPlansBadge, toggleSidebar, closeSidebar, setFlightPlansBadge }}
    >
      {props.children}
    </SidebarContext.Provider>
  );
};
